
export { ApiDictionary } from './resource/apidictionary.constants';
export { ApiResources as Resources } from './resource/resource.constants';

